import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IMOQValidationResponse } from './IMOQValidationResponse';

export const validateMOQ = (): AxiosPromise<IMOQValidationResponse> => {
  return Fetch().then(axios => axios.get('orders/validate-moq'));
};
